// extracted by mini-css-extract-plugin
export default {"claim_area":"Claim_claim_area__Vg-aY"};